<template>
  <div>
    <b-badge v-if="count" pill variant="neutral-success" class="text-success">
      <div style="width: 16px">
        {{ countString }}
      </div>
    </b-badge>
  </div>
</template>

<script>
export default {
  name: 'BadgeMessageCount',

  props: {
    count: {
      type: Number,
      default: null
    }
  },

  computed: {
    countString() {
      if (this.count < 100) {
        return this.count;
      } else {
        return '99+';
      }
    }
  }
};
</script>

<style></style>
